import * as React from 'react';

import DiscoveryFiltersTitle from 'modules/discovery/components/filters/title/DiscoveryFiltersTitle';
import Tooltip from 'components/Tooltip';

import './range-selector-title.scss';

type Props = {
  title: string,
  value?: string,
  tooltip?: string,
  isDisabled?: boolean
};

const RangeSelectorTitle = ({
  title,
  tooltip,
  value,
  isDisabled
}: Props) => (
  <DiscoveryFiltersTitle
    title={title}
    isDisabled={isDisabled}
  >
    {Boolean(tooltip) && (
      <div className="range-selector-title__tooltip">
        <Tooltip
          message={tooltip}
          showQuestionMark
        />
      </div>
    )}
    <div className="range-selector-title__value">
      {value}
    </div>
  </DiscoveryFiltersTitle>
);

export default RangeSelectorTitle;
